// extracted by mini-css-extract-plugin
export var cardIcon = "_6a-5";
export var cardIconUnframed = "_6a-9";
export var checkboxCard = "_6a-0";
export var checkboxCardSelected = "_6a-4";
export var disabled = "_6a-2";
export var interactive = "_6a-1";
export var outerBorder = "_6a-3";
export var spacerMedium = "_6a-8";
export var spacerSmall = "_6a-7";
export var spacerXsmall = "_6a-6";